import { createAsyncThunk } from "@reduxjs/toolkit";
import useFetch from "../../app/hooks";

export const Cities = createAsyncThunk(
    "cities/cities",
    async (_, { getState }) => {
        const { token } = getState().loginInfo;
        const result = useFetch({
            url: `townships`,
            method: "GET",
            token: token,
        });
        return result;
    }
);
